<template>
    <div>
        <header>
            <div class="header-title">
                <div style="display: flex; align-items: center;">
                    <p>问题描述详情</p>
                </div>
            </div>
        </header>
        <div class="container">
            <div class="inner-box">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px">
                    <el-row>
                        <el-col>
                            <el-form-item label="排序 : " prop="sortNo" size="small">
                                <span>{{ruleForm.sortNo}}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col>
                            <el-form-item label="问题标题 : " prop="title" size="small">
                                <span>{{ruleForm.title}}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col>
                            <el-form-item label="回答内容 : " prop="content" size="small">
                                <div style="height: 550px">
                                    <quill-editor ref="myTextEditor" v-model="ruleForm.content" :options="editorOption" style="height:500px;" disabled></quill-editor>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="附件信息 : " size="small">
                                <docUploadView
                                        :type="type"
                                        v-for="(item,index) in ruleForm.attachmentParamList"
                                        :key="index"
                                        :docItem.sync="item"
                                />
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <div class="bottom-btn">
                    <el-button @click="backToList()">返回</el-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {tabsCloseCurrentHandle} from '@/utils/routeTab'
    export default {
        data(){
            return {
                type: 'ent_base_info',
                ruleForm:{
                    sortNo:'',
                    title:'',
                    content:'',
                    attachmentParamList: [{//附件列表
                        Id: "",
                        citeId: "",
                        name: "",
                        fileType: 1,
                        filePath: "",
                        required: false,
                        attributes: {
                            attname: "",
                            delmethod: "2",
                            allows: '.pdf,.PDF'
                        }
                    }],
                },
                id:'',
                rules:{
                    sortNo:[
                        {required: true, message: '请输入序号', trigger: 'blur'},
                    ],
                    title:[
                        {required: true, message: '请输入标题', trigger: 'blur'},
                    ],
                    content:[
                        {required: true, message: '请输入回答内容', trigger: 'change'},
                    ],
                },
                editorOption: {
                    placeholder: '编辑文章内容'
                },
            }
        },
        created(){
            this.getRouterParams();
        },
        activated() {
            this.getRouterParams();
        },
        methods:{
            //获取路由参数
            getRouterParams(){
                if(!!this.$route.params.id){
                    this.id = this.$route.params.id;
                    this.getBasicInfo();
                }
            },
            //获取基本信息
            getBasicInfo(){
                this.$http.get('/question-help/one?id='+this.id).then(res=>{
                    if(res.data.code == 1){
                        this.ruleForm = res.data.data;
                    }
                })
            },
            backToList(){
                tabsCloseCurrentHandle();
                this.$router.push('/questionDiscretion/list');
            }
        }
    }
</script>
<style lang="scss" scoped>
    header{
        height: 68px;
        background: #fff;
        .header-title {
            height: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 20px 0 0;
            p {
                font-size: 18px;
                font-weight: bold;
                color: #000000;
                line-height: 24px;
                margin-left: 32px;
            }
        }
    }
    .container{
        width: 100%;
        padding: 20px;
        .inner-box{
            width: 100%;
            padding: 20px;
            background: #fff;
        }
    }
</style>